var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510.61 425.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e21c21;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.16,212.92h69.63V425.83h46.42V212.92h69.63L256,118.29ZM511.3,378.52V47.31C511.3,21.17,490.53,0,464.89,0H47.11C21.47,0,.7,21.17.7,47.31V378.52c0,26.14,20.77,47.31,46.41,47.31H186.37v-47H47.11V47H464.89V378.87H325.63v47H464.89C490.53,425.83,511.3,404.66,511.3,378.52Z",
    transform: "translate(-0.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadEdit);
export default __webpack_public_path__ + "static/media/upload-edit.f6518c96e0967e65b2ca56875d8503e8.svg";
export { ForwardRef as ReactComponent };